import { api } from "./apiClient";
import { getDirectoryLocationQuery } from "./eventDiscovery";

export function getArtistLocationQuery(city, discoveryLocation, radiusKm = 25) {
  return getDirectoryLocationQuery(city, radiusKm, discoveryLocation);
}

export function fetchArtists(filters = {}, options) {
  return api.get("/artists", { ...options, query: filters });
}

export function fetchAllArtists(options) {
  return api.get("/artists", { ...options, query: { page: 1, pageSize: 100 } });
}

export function fetchPopulatArtists(options) {
  return api.get("/artists/popular", options);
}

export function fetchArtistById(id, options) {
  return api.get(`/artists/${encodeURIComponent(id)}`, options);
}

export function fetchArtistEvents(id, options) {
  return api.get(`/artists/${encodeURIComponent(id)}/events`, options);
}

export function fetchArtistReviews(id, options) {
  return api.get(`/artists/${encodeURIComponent(id)}/reviews`, options);
}

export function fetchSimilarArtists(id, options) {
  return api.get(`/artists/${encodeURIComponent(id)}/similar`, options);
}

let metadataPromise;

function fetchMetadata() {
  metadataPromise ||= api.get("/artists/meta", {
    query: { registeredOnly: true },
  });
  return metadataPromise;
}

let genresPromise;
let genresExpiresAt = 0;

export function getAvailableGenres() {
  if (!genresPromise || Date.now() >= genresExpiresAt) {
    genresExpiresAt = Infinity;
    genresPromise = api.get("/artists/genres").then(({ genres }) => {
      genresExpiresAt = Date.now() + 60000;
      return ["All", ...genres.filter((genre) => genre !== "All")];
    }).catch((error) => {
      genresPromise = undefined;
      genresExpiresAt = 0;
      throw error;
    });
  }
  return genresPromise;
}

export async function getAvailableCities() {
  return (await fetchMetadata()).cities;
}
